export default __webpack_public_path__ + "static/media/Pre_comment.53305363.svg";